import React, { PureComponent } from "react";
// import ReactDOM from "react-dom";
import { Form, Icon as LegacyIcon } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import { QuestionCircleFilled } from "@ant-design/icons";
import {
  Input,
  Button,
  Select,
  Cascader,
  DatePicker,
  Radio,
  Switch,
  Message,
  AutoComplete,
  Spin,
  Upload,
  Tooltip,
  TreeSelect,
} from "antd";
import PropTypes from "prop-types";
import ScTransfer from "@/components/dataEntry/scTransfer";
import options from "@/components/dataEntry/areaPickerOption";
import "@/assets/stylus/com/display/form.styl";
import moment from "moment";
import "moment/locale/zh-cn";
import { closeModals } from "@/state/action/comAction";
import withCtxRef from "@/hoc/withCtxRef";
import RefreshGrid from "@/utils/refreshGrid";
import fetchHandler from "@/fetch/fetchHandler";
import ClassNames from "classnames";
import debounce from "lodash/debounce";
import "../../../assets/stylus/com/display/areapicker.styl";

import collect from "collect.js";
import ColorSelect from "@/components/display/color/ColorSelect";
import { ExportBtn } from "@/utils/exportBtn";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import functionTools from "../../../utils/Tool";

const FormItem = Form.Item;
const Option = Select.Option;
const AutoOption = AutoComplete.Option;
const TextArea = Input.TextArea;
const RangePicker = DatePicker.RangePicker;
const { MonthPicker } = DatePicker;
const RadioGroup = Radio.Group;

/*
 *  表单核心组件
 *  @ option layout {String} 表单布局形式
 *  @ option children {JSX} 表单插槽中定义的内容
 * */

@withCtxRef
@connect((state) => state)
class FormCore extends PureComponent {
  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  constructor(props) {
    super();
    this.props = props;
    this.internationalization = this.props.intl.messages.formCore;
    console.log(props);
    // 设置表单map
    this.state = {
      loading: !1,
      visible: {},
      disabled: {},
      fetching: false,
      fetchPickerOptions: [],
      birthdayOptions: [],
      fetchPickerOptions2: [],
      fetchPickerOptionsFetch: [],
      hasSet: false,
    };
    // 节流定时器
    this.searchTimeout = null;
    this.lastFetchId = 0;
    this.fetchUser = debounce(this.fetchUser, 800);
    this.loadCancider = true;
    // 定义级联相关初始化
    this.paramLen = 0;
    this.lazyFlag = !0;
    this.state.lazyOptions = [
      {
        loading: !0,
        label: "",
        value: "",
      },
    ];
    this.formMap = {
      input: this.formInputHive.bind(this),
      select: this.formSelectHive.bind(this),
      buttonGp: this.formButtonGpHive.bind(this),
      areaPicker: this.formAreaPickerHive.bind(this),
      date: this.formDatePickerHive.bind(this),
      switch: this.formSwitchHive.bind(this),
      radio: this.formRadioHive.bind(this),
      transfer: this.formTransferHive.bind(this),
      autoWatch: this.formAutoHive.bind(this),
      lazyOption: this.formLazyOptionHive.bind(this),
      children: this.childrenRender.bind(this),
      upload: this.uploadHive.bind(this),
      colorPicker: this.formColorPicker.bind(this),
      birthdayDate: this.formBirthdayHive.bind(this),
      inputGroup: this.formInputGroupHive.bind(this),
      cascader: this.formCascaderHive.bind(this), // 新增级联选择
      autoWatchFetch: this.formAutoFetchHive.bind(this), // 新增调用方法
      treeSelect: this.formTreeSelectHive.bind(this), // 树选择器
      endCodeSelect: this.formAutoFetchHiveEndCode.bind(this), // key,value 自动填充
    };

    // 设置规则map

    this.rulesMap = {
      phone: this.checkPhone.bind(this),
      length: this.checkLength.bind(this),
      check: this.checkSwitch.bind(this),
      date: this.checkDateNew.bind(this),
      // 数值的验证 数值范围
      numVal: this.checkNumVal.bind(this),
      // 正数验证
      positiveVal: this.checkPositiveVal.bind(this),
      // 正整数验证
      positiveInt: this.checkPositiveInt.bind(this),
      // 正整数验证(不含0)
      positiveIntNotZero: this.checkPositiveIntNotZero.bind(this),
      // 日期范围选择
      inOneMonth: this.checkMonthRange.bind(this),
    };
  }

  generateAreaOptions(isPickArea) {
    if (this.options) {
      return this.options;
    } else {
      this.options = options(isPickArea);
      return this.options;
    }
  }

  // fetchPickerOptions (dataApi,loaded) {
  // this.loadCancider&&fetchHandler(dataApi).then((res)=>{
  // if(res&&res.code=='success'){
  // this.loadCancider=false
  // return res.data
  // }
  // })
  // }

  // shouldComponentUpdate (nextProps, nextState) {
  //   // 重复渲染判断，将nextState转为新对象用来做对象判断，也可以使用immutable库。
  //   console.debug(this.props);
  //   console.debug(nextProps);
  //   return !Object.is(nextState, this.state) || !Object.is(this.props, nextProps);
  // }

  // 自定义页面渲染，插槽
  childrenRender(item) {
    return item.render();
  }

  // TreeSelect
  formTreeSelectHive(item) {
    return (
      <TreeSelect
        style={{ width: item.width ? item.width : "200px" }}
        treeData={item.data}
        onChange={item.onChange}
        placeholder={item.placeholder}
        allowClear
        className="form-core-tree-select"
        showSearch
        treeCheckable={item.treeCheckable}
        treeCheckStrictly={item.treeCheckStrictly}
        treeNodeFilterProp="title"
        showCheckedStrategy={item.showCheckedStrategy}
      />
    );
  }

  // 级联选择
  formCascaderHive(item) {
    return (
      <Cascader
        style={{ width: item.width ? item.width : "200px" }}
        options={item.options}
        loadData={(selectedOptions) => {
          if (item.optionsApi) {
            this.loadLazyData(selectedOptions, item);
          }
        }}
        onChange={this.onChange}
        changeOnSelect
      />
    );
  }

  // 获取fetchPickerOptions
  getFetchPickerOptions(item, value) {
    const searchParam = item.searchParam;
    searchParam[item.searchKey] = value;
    searchParam["page"] = 1;
    searchParam["pagecount"] = 100;
    fetchHandler(item.sourceApi, searchParam).then((res) => {
      if (res && res.code === "success") {
        const state = {};
        state[item.searchListName] = res.data;
        this.setState(state);
      }
    });
  }

  // 自动输入，数据项通过调用接口获取
  formAutoFetchHive(item) {
    // fetchPickerOptions
    console.log(this.state.fetchPickerOptionsFetch);
    return (
      <AutoComplete
        style={{ width: item.width ? item.width : "200px", paddingTop: "1px" }}
        onSearch={(value) => {
          clearTimeout(this.searchTimeout);
          this.searchTimeout = setTimeout(() => {
            this.getFetchPickerOptions(item, value);
          }, 200);
        }}
        onSelect={item.onSelect}
        onChange={item.onChange}
        placeholder={item.placeholder}>
        {this.state[item.searchListName]
          ? this.state[item.searchListName].map((optipon) => (
              <AutoOption
                key={optipon[item.optionInfo.optionKey]}
                value={optipon[item.optionInfo.optionText]}>
                {optipon[item.optionInfo.optionText]}
              </AutoOption>
            ))
          : null}
      </AutoComplete>
    );
  }

  // 自动输入，数据项通过调用接口获取
  formAutoFetchHiveEndCode(item) {
    // 获取数组
    if (!this.state.hasSet) {
      fetchHandler(item.sourceApi, {}).then((res) => {
        if (res && res.code === "success") {
          console.log(res.data);
          this.setState({
            fetchPickerOptions2: res.data,
            hasSet: true,
          });
        }
      });
    }
    return (
      <AutoComplete
        style={{ width: item.width ? item.width : "200px", paddingTop: "1px" }}
        filterOption={(inputValue, option) => {
          return option.value.indexOf(inputValue) !== -1;
        }}
        onSelect={item.onSelect}
        placeholder={item.placeholder}
        onChange={item.onChange}>
        {this.state.fetchPickerOptions2.map((optipon) => (
          <AutoOption key={optipon[item.keyParam]} value={optipon[item.choseParam]}>
            {optipon[item.showParam]}
          </AutoOption>
        ))}
      </AutoComplete>
    );
  }

  // 返回Input元素
  formInputHive(item) {
    if (item.inputType === "textarea") {
      return (
        <TextArea placeholder={item.placeholder} disabled={this.computedDisabled(item)}></TextArea>
      );
    } else if (item.addonAfter) {
      return (
        <Input
          type={item.inputType}
          step={0.01}
          maxLength={item.valueLength ? item.valueLength : 100}
          style={{ width: item.width ? item.width : "200px", paddingTop: "1px" }}
          ref={(input) => {
            item.inputObj = input;
          }}
          disabled={this.computedDisabled(item)}
          placeholder={item.placeholder}
          addonAfter={item.addonAfter}
          onBlur={(e) => {
            const val = this.props.form.getFieldValue(item.param.name);
            if (item.onBlur) {
              item.onBlur(this, e, val);
            }
          }}
          suffix={item.suffix ? item.suffix : ""}
        />
      );
    } else {
      return (
        <Input
          type={item.inputType}
          step={0.01}
          maxLength={item.valueLength ? item.valueLength : 100}
          style={{ width: item.width ? item.width : "200px" }}
          ref={(input) => {
            item.inputObj = input;
          }}
          disabled={this.computedDisabled(item)}
          placeholder={item.placeholder}
          onBlur={(e) => {
            const val = this.props.form.getFieldValue(item.param.name);
            if (item.onBlur) {
              item.onBlur(this, e, val);
            }
          }}
          suffix={item.suffix ? item.suffix : ""}
        />
      );
    }
  }

  // 返回Input连接框
  formInputGroupHive(inputGP) {
    const inputs = [];
    inputGP.inputGroup.forEach((item) => {
      if (item.addonAfter) {
        const inputItem = (
          <Input
            type={item.inputType}
            step={0.01}
            maxLength={item.valueLength ? item.valueLength : 100}
            style={{ width: item.width ? item.width : "200px", paddingTop: "1px" }}
            ref={(input) => {
              item.inputObj = input;
            }}
            disabled={this.computedDisabled(item)}
            placeholder={item.placeholder}
            addonAfter={item.addonAfter}
            onBlur={(e) => {
              const val = this.props.form.getFieldValue(item.param.name);
              if (item.onBlur) {
                item.onBlur(this, e, val);
              }
            }}
          />
        );
        inputs.push(inputItem);
      } else {
        const inputItem = (
          <Input
            type={item.inputType}
            step={0.01}
            maxLength={item.valueLength ? item.valueLength : 100}
            style={{ width: item.width ? item.width : "200px" }}
            ref={(input) => {
              item.inputObj = input;
            }}
            disabled={this.computedDisabled(item)}
            placeholder={item.placeholder}
            onBlur={(e) => {
              const val = this.props.form.getFieldValue(item.param.name);
              if (item.onBlur) {
                item.onBlur(this, e, val);
              }
            }}
          />
        );
        inputs.push(inputItem);
      }
    });
    return inputs;
  }

  // 颜色拾取器
  formColorPicker(item) {
    return <ColorSelect color={item.color} key={item.objKey} updateColor={item.updateColor} />;
  }

  // 返回自动联想元素
  formAutoHive(item) {
    if (!this[`${item.param.name}origin`]) {
      this[`${item.param.name}origin`] = [];
      fetchHandler(item.sourceApi).then((res) => {
        const sourceData = {};
        if (res && res.code === "success") {
          sourceData[item.param.name] = res.data.filter((d) => {
            return item.choseParam ? d[item.choseParam] : d;
          });
          this[`${item.param.name}origin`] = res.data.filter((d) => {
            return item.choseParam ? d[item.choseParam] : d;
          });
        } else {
          sourceData[item.param.name] = [];
        }
        this.setState(sourceData);
      });
    }
    return (
      <AutoComplete
        placeholder={item.placeholder}
        maxLength={item.valueLength ? item.valueLength : 100}
        disabled={this.computedDisabled(item)}
        dataSource={
          this.state[item.param.name]
            ? this.state[item.param.name].map((s) => (
                <AutoOption
                  value={item.choseParam ? s[item.choseParam] || "" : s}
                  key={item.keyParam ? s[item.choseParam] || "" : s}>
                  {item.showParam ? s[item.showParam] : s}
                </AutoOption>
              ))
            : []
        }
        onSearch={(value) => {
          this.handleSearch(
            value,
            this[`${item.param.name}origin`],
            item.showParam,
            item.param.name,
          );
        }}
      />
    );
  }

  formLazyOptionHive(item) {
    this.initLazyOptions(item);
    return (
      <Cascader
        ref={(input) => {
          item.inputObj = input;
        }}
        options={this.state.lazyOptions}
        disabled={this.computedDisabled(item)}
        loadData={(selectedOptions) => {
          this.loadLazyData(selectedOptions, item);
        }}
        onChange={this.onLazyChange}
        changeOnSelect
        placeholder={item.placeholder}>
      </Cascader>
    );
  }

  uploadHive() {
    return (
      <Upload name="logo" action="/upload.do" listType="picture">
        <Button>Click to upload</Button>
      </Upload>
    );
  }

  initLazyOptions(item) {
    const initParam = {};
    initParam[item.optionsParam] = item.optionsInitValue || "";
    if (this.lazyFlag) {
      fetchHandler(item.optionsApi, initParam).then((res) => {
        if (res && res.code === "success") {
          // res.data=typeof res.data=='object'?res.data.data:res.data;
          for (const r of res.data) {
            this.state.lazyOptions.push({
              label: r[item.optionsName],
              value: r[item.optionsValue],
              isLeaf: item.optionsLimit === 1 ? !0 : !1,
            });
          }
          this.state.lazyOptions[0].loading = !1;
          this.setState({
            lazyOptions: [...this.state.lazyOptions],
          });
        }
      });
    }
    this.lazyFlag = !1;
  }

  loadLazyData(selectedOptions, item) {
    // 获取当前点击选项
    console.debug(item);
    const targetOption = selectedOptions[selectedOptions.length - 1];
    targetOption.loading = true;
    const targetParam = {};
    targetParam[item.optionsParam] = targetOption.value;
    // 请求子层级选项
    fetchHandler(item.optionsApi, targetParam).then((res) => {
      if (res && res.code === "success") {
        // res.data=typeof res.data=='object'?res.data.data:res.data;
        targetOption.children = [];
        for (const r of res.data) {
          targetOption.children.push({
            label: r[item.optionsName],
            value: r[item.optionsValue],
            isLeaf: this.paramLen === item.optionsLimit - 1 ? !0 : !1,
          });
        }
      }
      targetOption.loading = false;
      this.setState({
        lazyOptions: [...this.state.lazyOptions],
      });
    });
  }

  onLazyChange = (value) => {
    console.debug("onLazyChange-----", value);
    this.paramLen = value.length;
  };

  handleSearch(v, source, showParam, name) {
    let filterSource = [];
    const sourceData = {};
    if (v !== "") {
      filterSource = source.filter((s) => {
        if (showParam && s[showParam] && s[showParam].indexOf(v) !== -1) {
          return true;
        }
        if (!showParam && s && s.indexOf(v) !== -1) {
          return true;
        }
        return false;
      });
      sourceData[name] = filterSource;
    } else {
      sourceData[name] = []; // 防止数据过多造成卡顿，清空搜索框的时候同步清除下拉框源数据
    }
    this.setState(sourceData);
  }

  // 对数值类数据进行排序
  sortingDigtalData(item, data) {
    if (item.dataApi.sortMethod === "Ascending") {
      // 升序
      const AscendingData = item.mapKey
        ? collect(data).sortBy(item.mapKey.value).all()
        : collect(data).sort().all();
      return AscendingData;
    } else {
      const DescendingData = item.mapKey
        ? collect(data).sortByDesc(item.mapKey.value).all()
        : collect(data)
            .sort((a, b) => {
              return b - a;
            })
            .all();
      return DescendingData;
    }
  }

  // 返回默认Select元素
  getSelectOptions(item) {
    const selectOptions1 = {};
    const queryParam = item.fetchQuery || {}; // 配置异步下拉框的请求参数fetchQuery:{}
    console.log("---getSelectOptions---");
    fetchHandler(item.dataApi.api, queryParam).then((res) => {
      if (res && res.code === "success") {
        let findFinallyData = res.data;
        // 获取正确路径的数组数据
        if (item.dataApi.dataPath) {
          for (const rd of item.dataApi.dataPath) {
            findFinallyData = findFinallyData[rd];
          }
        }
        if (item.dataApi.addAll) {
          findFinallyData.unshift("全部");
        }
        // 对数值类数据排序
        if (item.dataApi.sortMethod) {
          findFinallyData = this.sortingDigtalData(item, findFinallyData);
        }
        selectOptions1[item.param.name] = item.options
          ? item.options.concat(findFinallyData)
          : findFinallyData;
        this.setState({ ...this.state, ...selectOptions1 });
        console.debug("select---", this.state);
        // debugger
      }
    });
    item.dataApi.loaded = !0;
  }

  // 远程搜索数据源接口
  fetchUser(value, item) {
    const selectOptions1 = {};
    this.lastFetchId += 1;
    const fetchId = this.lastFetchId;
    this.setState({
      fetching: true,
    });
    if (item.searchParam && functionTools.notNull(value)) {
      fetchHandler(item.dataApi.api, {
        [item.searchParam]: value,
      }).then((res) => {
        if (res && res.code === "success") {
          if (fetchId !== this.lastFetchId) {
            // for fetch callback order
            return;
          }
          let findFinallyData = res.data;
          // 获取正确路径的数组数据
          if (item.dataApi.dataPath) {
            for (const rd of item.dataApi.dataPath) {
              findFinallyData = findFinallyData[rd];
            }
          }
          // 对数值类数据排序
          if (item.dataApi.sortMethod) {
            findFinallyData = this.sortingDigtalData(item, findFinallyData);
          }
          selectOptions1[item.param.name] = item.options
            ? item.options.concat(findFinallyData)
            : findFinallyData;
          this.setState({ ...this.state, ...selectOptions1 });
          this.setState({
            fetching: false,
          });
        }
      });
    }
  }

  formSelectHive(item) {
    let selectOptions = item.options || [];
    // console.log(item.options);
    if (item.dataApi) {
      if (!item.dataApi.loaded) {
        this.getSelectOptions(item);
      }
      selectOptions = this.state[item.param.name] || [];
    }
    return (
      <Select
        mode={item.selectType}
        style={{
          minWidth: item.width ? item.width : "200px",
          width: item.width ? item.width : "200px",
        }}
        disabled={this.computedDisabled(item)}
        placeholder={item.placeholder}
        showSearch={item.showSearch}
        optionFilterProp={item.filterOption ? "children" : "value"}
        dropdownMatchSelectWidth={
          item.dropdownMatchSelectWidth ? item.dropdownMatchSelectWidth : true
        }
        // getPopupContainer={this.getPopupContainer}
        onSearch={(value) => {
          if (item.search) {
            this.fetchUser(value, item);
          }
        }}
        onChange={(value) => {
          this.visibleChange(value, item);
          // select变化
          const formInstance = this.props.form;
          if (item.onChange) {
            item.onChange(value, formInstance);
          }
        }}
        filterOption={item.filterOption || false}
        notFoundContent={this.state.fetching ? <Spin size="small" /> : null}
        labelInValue={item.labelInValue}>
        {selectOptions.map((op) => {
          if (this.state[item.param.name] && item.dataApi) {
            if (item.mapKey) {
              return (
                <Option key={op[item.mapKey.text]} value={op[item.mapKey.value]}>
                  {op[item.mapKey.text]}
                </Option>
              );
            } else {
              return (
                <Option key={op} value={op === this.internationalization.all ? "" : op}>
                  {op}
                </Option>
              );
            }
          } else {
            return (
              <Option key={op.text} value={op.value}>
                {op.text}
              </Option>
            );
          }
        })}
      </Select>
    );
  }

  // 返回radio元素

  formRadioHive(item) {
    return (
      <RadioGroup
        onChange={(e) => this.visibleChange(e, item)}
        disabled={this.computedDisabled(item)}>
        {item.options.map((op) => (
          <Radio key={op.text} value={op.value}>
            {op.text}
          </Radio>
        ))}
      </RadioGroup>
    );
  }

  // 返回按钮交互元素

  formButtonGpHive(item) {
    const buttons = [];
    item.buttonArr.forEach((btn, index) => {
      if (btn.btnType === "submit") {
        buttons.push(
          <Button
            type="primary"
            icon={btn.icon ? <LegacyIcon type={btn.icon} /> : null}
            disabled={this.computedDisabled(btn)}
            loading={this.state.loading}
            className="sc-form-btn"
            key="submit"
            htmlType="submit">
            {btn.text}
          </Button>,
        );
      }
      if (btn.btnType === "formSubmit") {
        buttons.push(
          <Button
            type="primary"
            icon={btn.icon ? <LegacyIcon type={btn.icon} /> : null}
            loading={this.state.loading}
            className="sc-form-btn"
            key="form_submit"
            disabled={this.computedDisabled(btn)}
            onClick={this.handleSubmit}>
            {btn.text}
          </Button>,
        );
      }
      if (btn.btnType === "reset") {
        buttons.push(
          <Button
            type="default"
            icon={btn.icon ? <LegacyIcon type={btn.icon} /> : null}
            className="sc-form-btn"
            key="reset"
            onClick={this.handleReset}>
            {btn.text}
          </Button>,
        );
      }
      if (btn.btnType === "expBtn") {
        buttons.push(
          <ExportBtn
            serviceName={btn.params.serviceName}
            fileName={btn.params.fileName}
            tableKey={btn.params.tableKey}
            handleParams={btn.handleParams}
            checkParams={btn.checkParams}
          />,
        );
      }
      if (btn.btnType === "button") {
        const btnText = typeof btn.render === "function" ? btn.render() : btn.text;
        const buttonItemPush = (
          <Button
            type={btn.btnTheme ? btn.btnTheme : "primary"}
            icon={btn.icon ? <LegacyIcon type={btn.icon} /> : null}
            disabled={this.computedDisabled(btn)}
            onClick={(e) => {
              e.preventDefault();
              if (btn.dontValid) {
                const fieldsValue = this.props.form.getFieldsValue();
                this.dataActions("", fieldsValue);
                let fieldsParam = {};
                fieldsParam = this.props.formConfig.defaultParams
                  ? Object.assign(this.props.formConfig.defaultParams, fieldsValue)
                  : fieldsValue;
                btn.handler(this, fieldsParam);
              } else {
                this.props.form.validateFields((err, values) => {
                  // 默认需要验证表单，如果dontValid为true，则不走验证
                  if (!err) {
                    const fieldsValue = values;
                    this.dataActions(err, values);
                    let fieldsParam = {};
                    fieldsParam = this.props.formConfig.defaultParams
                      ? Object.assign(this.props.formConfig.defaultParams, fieldsValue)
                      : fieldsValue;
                    btn.handler(this, fieldsParam);
                  }
                });
              }
            }}
            className="sc-form-btn"
            key={`button${index}`}>
            {btnText}
          </Button>
        );
        if (btnText) {
          buttons.push(buttonItemPush);
        } else {
          buttons.push(<span></span>);
        }
      }
      if (btn.message) {
        buttons.unshift(
          <Tooltip
            title={() => {
              return <span style={{ color: "#000" }}>{btn.message}</span>;
            }}
            color="#ffffff"
            overlayClassName="white-tooltip">
            <QuestionCircleFilled style={{ color: "#D9D9D9", marginRight: "24px" }} />
          </Tooltip>,
        );
      }
    });
    return buttons;
  }

  // 加载生日日期
  loadBirthdayData = (selectedOptions) => {
    this.birthdayConditions = () => new Map([
        [/^((1|3|5|7|8)|(1[0|2]))$/, this.setBirthdayDate(31)], // 大月31天
        [/^2$/, this.setBirthdayDate(29)], // 特殊月 28/29天
        [/^((4|6|9)|(1[1]))$/, this.setBirthdayDate(30)], // 小月30天
        // ['default',null]
      ]);
    console.log("----selectedOptions", selectedOptions);
    if (selectedOptions && selectedOptions.length) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      const action = [...this.birthdayConditions()].filter(([key]) => {
        return key.test(+targetOption.value);
      });
      targetOption.children = !targetOption.isLeaf ? action[0][1] : null;
    }
    this.setState({
      birthdayOptions: [...this.state.birthdayOptions],
    });
  };

  // 生日组件
  formBirthdayHive(item) {
    return (
      <Cascader
        options={this.state.birthdayOptions}
        popupClassName={item.className}
        loadData={this.loadBirthdayData}
        disabled={this.computedDisabled(item)}
        notFoundContent={this.internationalization.msg1}
        changeOnSelect={item.pickOnSelect}
        displayRender={item.displayRender}
        style={{ width: item.width ? item.width : "200px" }}
        placeholder={item.placeholder}
      />
    );
  }

  // 构建地区联动选择

  formAreaPickerHive(item) {
    if (item.sourceApi) {
      if (this.loadCancider) {
        fetchHandler(item.sourceApi).then((res) => {
          if (res && res.code === "success") {
            this.state.fetchPickerOptions = res.data;
            let formatOptionsStr = JSON.stringify(this.state.fetchPickerOptions);
            formatOptionsStr = formatOptionsStr.replace(
              new RegExp(item.mapKey.label, "g"),
              "label",
            );
            formatOptionsStr = formatOptionsStr.replace(
              new RegExp(item.mapKey.value, "g"),
              "value",
            );
            formatOptionsStr = formatOptionsStr.replace(
              new RegExp(item.mapKey.children, "g"),
              "children",
            );

            this.setState({
              fetchPickerOptions: JSON.parse(formatOptionsStr),
            });
          }
        });
      }
      this.loadCancider = !1;
      return (
        <Cascader
          options={this.state.fetchPickerOptions}
          style={{ width: item.width ? item.width : "200px" }}
          popupClassName={item.className}
          disabled={this.computedDisabled(item)}
          notFoundContent={this.internationalization.msg1}
          changeOnSelect={item.pickOnSelect}
          placeholder={item.placeholder}
        />
      );
    } else {
      return (
        <Cascader
          changeOnSelect={item.pickOnSelect}
          popupClassName={item.className}
          style={{ width: item.width ? item.width : "200px" }}
          disabled={this.computedDisabled(item)}
          options={this.generateAreaOptions.bind(this)(item.isPickArea)}
          placeholder={item.placeholder}
        />
      );
    }
  }

  loadData = (selectedOptions, sourceApi, nextParam) => {
    const targetOption = selectedOptions[selectedOptions.length - 1];
    targetOption.loading = true;

    // load options lazily
    fetchHandler(sourceApi, nextParam).then((res) => {
      if (res && res.code === "success") {
        targetOption.loading = false;
        targetOption.children = res;
        // this.setState({
        // options: [...this.state.options],
        // });
      } else {
        console.debug(this.internationalization.msg2);
      }
    });
  };

  // 构建日期选择

  formDatePickerHive(item) {
    const disabledDate = (current) => {
      if (item.range) {
        return (
          (current && current > moment().subtract(item.range[1], item.rangeType || "days")) ||
          (current && current < moment().subtract(item.range[0], item.rangeType || "days"))
        );
      }
      return current && current > moment().endOf("day");
    };
    const disabledTime = (current) => {
      return current && current < moment().startOf("hour").fromNow();
    };
    let flag = false;
    if (item.allowClear === false || item.allowClear === true) {
      flag = true;
    }
    switch (item.dateType) {
      case "pickYear":
        return (
          <DatePicker
            picker="year"
            allowClear={flag ? item.allowClear : true}
            style={{ width: item.width ? item.width : "100%" }}
            disabled={this.computedDisabled(item)}
            onChange={item.onChange ? item.onChange : () => {}}
            disabledDate={item.disabledDate ? item.disabledDate : disabledDate}
            placeholder={item.placeholder}
          />
        );
      case "pickMonth":
        return (
          <MonthPicker
            picker="month"
            allowClear={flag ? item.allowClear : true}
            style={{ width: item.width ? item.width : "100%" }}
            disabled={this.computedDisabled(item)}
            onChange={item.onChange ? item.onChange : () => {}}
            disabledDate={item.disabledDate ? item.disabledDate : disabledDate}
            placeholder={item.placeholder}
          />
        );
      case "pickDate":
        return (
          <DatePicker
            style={{ width: item.width ? item.width : "100%" }}
            allowClear={flag ? item.allowClear : true}
            disabled={this.computedDisabled(item)}
            onChange={item.onChange ? item.onChange : () => {}}
            disabledDate={item.disabledDate ? item.disabledDate : disabledDate}
            placeholder={item.placeholder}
          />
        );
      case "pickDateTime":
        return (
          <DatePicker
            style={{ width: item.width ? item.width : "100%" }}
            disabled={this.computedDisabled(item)}
            allowClear={flag ? item.allowClear : true}
            onChange={item.onChange ? item.onChange : () => {}}
            disabledTime={item.disabledToNow && disabledTime}
            disabledDate={disabledDate}
            showTime
            format="YYYY-MM-DD HH:mm:ss"
            placeholder={item.placeholder}
          />
        );
      case "rangeDate":
        return (
          <RangePicker
            style={{ width: item.width ? item.width : "100%" }}
            allowClear={flag ? item.allowClear : true}
            ranges={item.defaultRanges ? item.defaultRanges : null}
            disabled={this.computedDisabled(item)}
            placeholder={item.placeholder ? item.placeholder : ["开始日期", "结束日期"]}
            onChange={item.onChange ? item.onChange : () => {}}
            disabledDate={disabledDate}
          />
        );
      case "rangeDateTime":
        return (
          <RangePicker
            style={{ width: item.width ? item.width : "100%" }}
            disabled={this.computedDisabled(item)}
            allowClear={flag ? item.allowClear : true}
            onChange={item.onChange ? item.onChange : () => {}}
            disabledTime={item.disabledToNow && disabledTime}
            disabledDate={disabledDate}
            showTime
            format="YYYY-MM-DD HH:mm:ss"
          />
        );
      case "rangeMonth":
        return (
          <RangePicker
            picker="month"
            style={{ width: item.width ? item.width : "100%" }}
            allowClear={flag ? item.allowClear : true}
            onChange={item.onChange ? item.onChange : () => {}}
            // mode={['month', 'month']}
            // format="YYYY-MM"
            // ref = {item.ref}
            // onPanelChange = {item.panelChange}
            disabledDate={(current) => {
              // Can not select days before today and today
              return current && current < moment(new Date("2015-01-01")).endOf("day");
            }}
            disabled={this.computedDisabled(item)}
          />
        );
      case "rangePicker":
        return (
          <RangePicker
            style={{ width: item.width ? item.width : "100%" }}
            allowClear={flag ? item.allowClear : true}
            disabled={this.computedDisabled(item)}
            onChange={item.onChange ? item.onChange : () => {}}
            disabledTime={item.disabledToNow && disabledTime}
            disabledDate={disabledDate}
            showTime
            format="YYYY-MM"
          />
        );
      default:
        return (
          <DatePicker
            disabled={this.computedDisabled(item)}
            allowClear={flag ? item.allowClear : true}
            onChange={item.onChange ? item.onChange : () => {}}
            disabledDate={disabledDate}
            placeholder={item.placeholder}
          />
        );
    }
  }

  // 构建开关
  formSwitchHive(item) {
    return <Switch onChange={item.onChange && item.onChange.bind(this, this.props.form)} />;
  }

  // 构建穿梭框
  formTransferHive(item) {
    // 过滤inline布局
    if (this.props.formConfig.layout === "inline") {
      Message.warning(this.internationalization.msg3, 1);
    }
    return (
      <ScTransfer
        transferConfig={{
          type: item.transType,
          titles: item.titles,
          placeholder: item.placeholder,
          nofound: item.nofound,
          key: item.key,
          itemUnit: item.unit,
        }}
      />
    );
  }

  /*
   *  validate 定义
   * */

  // 验证字符串长度

  checkLength(rule, value, callback, item) {
    if ((value && value.length > item.max_val) || (value && value.length < item.min_val)) {
      callback(
        `${this.internationalization.msg4}${item.min_val}${this.internationalization.msg4_2}${item.max_val}${this.internationalization.msg4_3}`,
      );
    }
    callback();
  }

  // 验证数值大小
  checkNumVal(rule, value, callback, item) {
    // eslint-disable-next-line no-useless-escape
    const number = /^(\-|\+)?\d+(\.\d+)?$/;
    if (
      (value && item.max_val && +value > +item.max_val) ||
      (value && item.min_val && +value < +item.min_val)
    ) {
      callback(
        `${this.internationalization.msg5}${item.min_val}${
          item.max_val
            ? this.internationalization.msg5_2 + this.internationalization.msg5_3 + item.max_val
            : ""
        }`,
      );
    } else if (
      value &&
      item.max_point &&
      value.split(".") &&
      value.split(".")[1] &&
      value.split(".")[1].length > +item.max_point
    ) {
      callback(`${this.internationalization.msg6}${item.max_point}`);
    } else if (value && !number.test(value)) {
      callback(this.internationalization.msg7);
    } else {
      callback();
    }
  }

  // 正数校验
  checkPositiveVal(rule, value, callback, item) {
    const positiveInt = /^\d+(\.\d+)?$/;
    // const positiveInt=/^0\.\d+$|^[1-9]+(\.\d+)?$/;
    if ((value && +value > +item.max_val) || (value && +value < +item.min_val)) {
      callback(
        `${this.internationalization.msg5}${item.min_val}${
          item.max_val
            ? this.internationalization.msg5_2 + this.internationalization.msg5_3 + item.max_val
            : ""
        }`,
      );
    } else if (
      value &&
      item.max_point &&
      value.split(".") &&
      value.split(".")[1] &&
      value.split(".")[1].length > +item.max_point
    ) {
      callback(`${this.internationalization.msg6}${item.max_point}`);
    } else if (value && !positiveInt.test(value)) {
      callback(this.internationalization.msg8);
    } else {
      callback();
    }
  }

  // 验证数值是否是正整数(含0)
  checkPositiveInt(rule, value, callback, item) {
    const positiveInt = /^[+]{0,1}(\d+)$/;
    if ((value && +value > +item.max_val) || (value && +value < +item.min_val)) {
      callback(
        `${this.internationalization.msg9}${item.min_val}${this.internationalization.msg9_3}${
          item.max_val
            ? this.internationalization.msg9_2 + item.max_val + this.internationalization.msg9_3
            : ""
        }`,
      );
    } else if (value && !positiveInt.test(value)) {
      callback(this.internationalization.msg10);
    } else {
      callback();
    }
  }

  // 验证数值是否是正整数(不含0)
  checkPositiveIntNotZero(rule, value, callback, item) {
    const positiveInt = /^[0-9]*[1-9][0-9]*$/;
    if ((value && +value > +item.max_val) || (value && +value < +item.min_val)) {
      callback(
        `${this.internationalization.msg9}${item.min_val}${this.internationalization.msg9_3}${
          item.max_val
            ? this.internationalization.msg9_2 + item.max_val + this.internationalization.msg9_3
            : ""
        }`,
      );
    } else if (value && !positiveInt.test(value)) {
      callback(this.internationalization.msg11);
    } else {
      callback();
    }
  }

  // 验证手机号码

  checkPhone(rule, value, callback) {
    const phoneReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    if (value && !phoneReg.test(value)) {
      callback(this.internationalization.msg12);
    }
    callback();
  }

  // 验证开关

  checkSwitch(rule, value, callback) {
    if (!value) {
      callback(this.internationalization.msg13);
    }
    callback();
  }

  // 验证选择日期长度

  checkDate(rule, value, callback, item) {
    console.debug(this.internationalization.msg14, rule, value, callback, item);
    const distanceDate =
      value && Math.ceil(value[1] && value[1].diff(value[0]) / (1e3 * 60 * 60 * 24));
    if (item.notOverYear) {
      // 如果不可以跨年查询
      if (moment(value[0]).format("YYYY") !== moment(value[1]).format("YYYY")) {
        callback(this.internationalization.msg15);
      }
    }
    if (value && distanceDate + 1 > item.max_val && item.max_val !== "") {
      callback(
        `${this.internationalization.msg16}${item.max_val}${this.internationalization.msg19}`,
      );
    } else if (value && distanceDate + 1 < item.min_val && item.min_val !== "") {
      callback(
        `${this.internationalization.msg17}${item.min_val}${this.internationalization.msg19}`,
      );
    } else {
      callback();
    }
  }

  checkDateNew(rule, value, callback, item) {
    if (value && value[0]) {
      const starDate = moment(value[0]);
      const endDate = moment(value[1]);
      const diffDate = endDate.diff(starDate, "days") + 1;
      console.debug(this.internationalization.msg18, value, diffDate);
      if (diffDate > item.max_val) {
        callback(
          `${this.internationalization.msg16}${item.max_val}${this.internationalization.msg19}`,
        );
      } else if (diffDate < item.min_val) {
        callback(
          `${this.internationalization.msg17}${item.min_val}${this.internationalization.msg19}`,
        );
      } else {
        callback();
      }
    } else {
      callback();
    }
    if (item.notOverYear) {
      // 如果不可以跨年查询
      if (moment(value[0]).format("YYYY") !== moment(value[1]).format("YYYY")) {
        callback(this.internationalization.msg15);
      }
    }
  }

  // 月份区间 max_Val
  checkMonthRange(rule, value, callback, item) {
    if (value && value[0]) {
      // 判断月份区间
      const dateRange = moment(value[0]).diff(moment(value[1]), "days");
      console.log(dateRange);
      if (dateRange <= 31 * (item.range + 1) && dateRange >= -31 * (item.range + 1)) {
        const month1 = moment(value[0]).format("MM");
        const month2 = moment(value[1]).format("MM");
        if (parseInt(month2) - parseInt(month1) <= item.range) {
          const starDate = moment(value[0]);
          const endDate = moment(value[1]);
          const diffDate = endDate.diff(starDate, "days");
          console.log(diffDate);
          console.log(item.max_Val);
          if (item.max_Val && diffDate > item.max_Val) {
            callback(
              `${this.internationalization.msg16}${item.max_Val}${this.internationalization.msg19}`,
            );
          } else if (item.min_val && diffDate < item.min_val) {
            callback(
              `${this.internationalization.msg17}${item.min_val}${this.internationalization.msg19}`,
            );
          } else {
            callback();
          }
          callback();
        } else {
          callback(item.range ? `查询月份不可超过${item.range}${1}个月` : "不可跨月查询");
        }
      } else {
        callback(item.range ? `查询月份不可超过${item.range}${1}个月` : "不可跨月查询");
      }
      callback();
    }
    callback();
  }

  // 清空参数

  handleReset = () => {
    const resetHandlers = this.context.store.getState().modalInfo.modalHandles.reset;
    if (resetHandlers && resetHandlers.length) {
      for (const f of resetHandlers) {
        f();
      }
    } else {
      this.props.form.resetFields();
    }
  };

  // 验证可见性和禁用

  visibleChange(e, item) {
    if (e) {
      this.state.visible[item.param ? item.param.name : item] = e.target ? e.target.value : e;
      this.state.disabled[item.param ? item.param.name : item] = e.target ? e.target.value : e;
    }
    this.setState({
      visible: this.state.visible,
      disabled: this.state.disabled,
      fetching: false,
    });
  }

  dataActions(err, values) {
    // 数据提交前的处理

    const fieldsValue = values;
    this.props.formConfig.childItems.forEach((item) => {
      // 外部HOC自定义数据格式化
      if (item.format && typeof item.format === "function") {
        const formatedVal = item.format(values[item.param.name]);
        fieldsValue[item.param.name] = formatedVal;
        console.log(item.param);
        console.log(fieldsValue);
      }

      if (item.type === "date" && values[item.param.name]) {
        if (item.dateType === "pickDate") {
          fieldsValue[item.param.name] = values[item.param.name].format("YYYY-MM-DD");
        }
        if (item.dateType === "pickDateTime") {
          fieldsValue[item.param.name] = values[item.param.name].format("YYYY-MM-DD HH:mm:ss");
        }
        if (
          item.dateType === "rangeDate" &&
          values[item.param.name] &&
          values[item.param.name].length > 0
        ) {
          fieldsValue[item.param.name] = `${values[item.param.name][0].format(
            "YYYY-MM-DD",
          )},${values[item.param.name][1].format("YYYY-MM-DD")}`;
        }
        if (item.dateType === "rangeDateTime") {
          fieldsValue[item.param.name] = `${values[item.param.name][0].format(
            "YYYY-MM-DD HH:mm:ss",
          )},${values[item.param.name][1].format("YYYY-MM-DD HH:mm:ss")}`;
        }
        if (item.dateType === "rangePicker") {
          fieldsValue[item.param.name] = `${values[item.param.name][0].format("YYYY-MM")},${values[
            item.param.name
          ][1].format("YYYY-MM")}`;
        }
      }
      if (item.format) {
        console.log(values[item.param.name], item.format);
        fieldsValue[item.param.name] =
          values[item.param.name] &&
          typeof values[item.param.name] === "object" &&
          values[item.param.name].length > 1
            ? `${values[item.param.name][0].format(item.format)},${values[
                item.param.name
              ][1].format(item.format)}`
            : values[item.param.name] || "";
      }

      if (item.type === "input" && item.inputType !== "textarea" && fieldsValue[item.param.name]) {
        fieldsValue[item.param.name] = fieldsValue[item.param.name].toString().trim();
      }
      if (item.radio && !item.radio.checked) {
        delete fieldsValue[item.param.name];
      }
      if (item.type === "lazyOption" || item.type === "areaPicker") {
        fieldsValue[item.param.name] =
          fieldsValue[item.param.name] && fieldsValue[item.param.name].join(",");
      }
      if (
        item.type === "select" &&
        item.selectType === "multiple" &&
        values[item.param.name] &&
        item.param.mapKey &&
        item.param.mapValue
      ) {
        fieldsValue[item.param.name] = JSON.parse(
          JSON.stringify(fieldsValue[item.param.name])
            .replace(/key/g, item.param.mapValue)
            .replace(/label/g, item.param.mapKey),
        );
      }
      if (item.type === "transfer") {
        console.log(this.context.store.getState().modalInfo.param);
        if (this.context.store.getState().modalInfo.param[item.key[1]]) {
          fieldsValue[item.param.name] = this.context.store
            .getState()
            .modalInfo.param[item.key[1]].join(",");
        }
      }
    });
    return fieldsValue;
  }

  submitCallback() {
    if (this.context.store.getState().modalInfo.visible === !0) {
      if (this.props.formConfig.stack) {
        this.props.formConfig.stack();
      } else {
        this.context.store.dispatch(closeModals());
      }
    }
  }

  // 提交查询

  handleSubmit = (e) => {
    if (e) {
      e.preventDefault();
    }
    this.props.form.validateFields((err, values) => {
      if (!err) {
        // let fieldsValue = values;

        // 提交数据格式化
        const fieldsValue = this.dataActions(err, values);
        let fieldsParam = {};
        fieldsParam = this.props.formConfig.defaultParams
          ? { ...this.props.formConfig.defaultParams, ...fieldsValue }
          : fieldsValue;
        if (this.props.handleParams) {
          fieldsParam = this.props.handleParams(fieldsParam);
        }
        if (this.props.formConfig.formTarget === "grid") {
          this.loading();
          const gridResult = this.props.fetchApi
            ? this.props.fetchApi(fieldsParam, this)
            : fieldsParam;
          fieldsParam = gridResult || fieldsParam;
          if (gridResult === false) {
            this.setState({
              loading: !1,
            });
            return;
          }
          this.fetchGrid(fieldsParam, this.props.formConfig.tableKey);
        } else {
          const fetchPromise = this.props.fetchApi(fieldsParam, this);
          if (fetchPromise) {
            this.loading();
          }
          if (fetchPromise) {
            fetchPromise.then((res) => {
              // 执行请求返回成功， 执行清空
              if (res && res.code === "success") {
                if (this.props.formConfig.formTarget === "refresh") {
                  RefreshGrid(this.context.store, this.props.formConfig.tableKey).then(() => {
                    // 请求成功并附带刷新grid调用
                    this.setState(
                      {
                        loading: !1,
                      },
                      () => {
                        this.submitCallback();
                      },
                    );
                  });
                } else {
                  if (this.props.formConfig.formTarget === "formSubmit") {
                    this.handleReset();
                  }
                  this.setState(
                    {
                      loading: !1,
                    },
                    () => {
                      this.submitCallback();
                    },
                  );
                }
              } else {
                // 请求失败调用
                this.setState(
                  {
                    loading: !1,
                  },
                  () => {
                    this.submitCallback();
                  },
                );
              }
            });
          }
        }
      }
    });
  };

  fetchGrid(fieldsParam, key) {
    const store = this.context.store;
    const params = this.props.formConfig.refresh
      ? store.getState().gridsInfo.param
      : { ...fieldsParam };
    const context = store.getState().gridsInfo.context[key];
    const formRes = store.getState().gridsInfo.fetchDataHandler.bind(context)(!0, {
      ...params,
      isBtnSearch: true,
    });
    if (formRes) {
      formRes.then(() => {
        this.loaded();
      });
    }
    return formRes;
  }

  loading() {
    this.setState({
      loading: !0,
    });
  }

  loaded() {
    this.setState({
      loading: !1,
    });
  }

  // radio选择Handler Fuc

  radioHandler(e, index, groupName) {
    this.props.formConfig.childItems.forEach((i) => {
      if (i.radio && i.radio.radioGroup === groupName) {
        i.radio.checked = !1;
      }
    });
    this.props.formConfig.childItems[index].radio.checked = !0;
    const formConfig = { ...this.props.formConfig };
    this.props.formConfig.context.setState({
      formConfig,
    });
  }

  // 禁用逻辑
  computedDisabled(item) {
    return item.disabledRule ? item.disabledRule(this.state.disabled) : item.disabled;
  }

  // 显示逻辑
  computedVisible(item) {
    if (typeof item.visibleRule === "object") {
      return (
        !item.visibleRule || this.state.visible[item.visibleRule.name] === item.visibleRule.value
      );
    } else {
      return !item.visibleRule || item.visibleRule(this.state.visible);
    }
  }

  // getPopupContainer = () => {
  //   return ReactDOM.findDOMNode(this.refs.formCore);
  //   // return this.formCoreRef;
  // };

  render() {
    const locale = this.props.intl.locale;
    if (locale === "zh") {
      moment.locale("zh-cn");
    } else {
      moment.locale("en-en");
    }

    const { getFieldDecorator } = this.props.form;
    // 暴露上下文到外部组件
    if (this.props.formConfig && this.props.formConfig.dispatchFields) {
      this.props.formConfig.dispatchFields(this);
    }
    const { layout, childItems } = this.props.formConfig;
    console.log(layout);
    return (
      <Form
        layout={layout}
        onSubmit={this.handleSubmit}
        className="sc-form newFormCore"
        // ref={(formCoreRef) => this.formCoreRef = formCoreRef}
        ref="formCore">
        {childItems.map((item, i) => {
          const Plugin = item.plugin;
          let itemvaluePropName;
          if (item.valuePropName) {
            itemvaluePropName = item.valuePropName;
          } else if (item.type === "switch") {
            itemvaluePropName = "checked";
          } else if (item.type === "upload") {
            itemvaluePropName = "fileList";
          } else {
            itemvaluePropName = "value";
          }
          return (
            this.computedVisible(item) && (
              <div
                key={`${item.type}${i}`}
                className={ClassNames({
                  "sc-inline": !item.newLine && layout === "inline",
                  "new-inline": item.newLine && layout === "inline",
                  "inline-Arry": item.isArray,
                })}>
                {item.isArray &&
                  item.inputGroup.map((input, index) => {
                    let valuePropName;
                    if (input.valuePropName) {
                      valuePropName = input.valuePropName;
                    } else if (input.type === "switch") {
                      valuePropName = "checked";
                    } else if (input.type === "upload") {
                      valuePropName = "fileList";
                    } else {
                      valuePropName = "value";
                    }
                    return (
                      <FormItem
                        className={`${layout === "inline" ? "sc-form-list" : "sc-row"} ${
                          (item.button || item.radio) && "Min-width"
                        }`}
                        style={{ width: `${input.width}px` }}
                        key={`${input.type}${index}`}
                        label={input.labelName}
                        colon={input.colon}>
                        {input.param
                          ? getFieldDecorator(input.param.name, {
                              rules: [
                                {
                                  type: input.param.type,
                                  required: input.requiredRule
                                    ? this.state.visible[input.requiredRule.name] ===
                                      input.requiredRule.value
                                    : input.required,
                                  message: "请输入内容",
                                },
                                {
                                  type: input.param.type,
                                  validator: input.validator
                                    ? (rule, value, callback) => {
                                        this.rulesMap[input.validator.vtype](
                                          rule,
                                          value,
                                          callback,
                                          input.validator,
                                        );
                                      }
                                    : null,
                                },
                              ],
                              valuePropName: valuePropName,
                              initialValue: input.defaultValue,
                              getValueFromEvent: input.getValueFromEvent,
                            })(
                              input.type ? (
                                this.formMap[input.type](input)
                              ) : (
                                <Plugin
                                  key={input.param.name}
                                  values={input.defaultValue}
                                  paramName={input.param.name}
                                  getFieldDecorator={getFieldDecorator}
                                  disabled={this.computedDisabled(input)}
                                />
                              ),
                            )
                          : this.formMap[input.type](input)}
                      </FormItem>
                    );
                  })}
                {!item.isArray && (
                  <FormItem
                    className={`${layout === "inline" ? "sc-form-list" : "sc-row"} ${
                      (item.button || item.radio) && "Min-width"
                    }`}
                    style={{ width: `${item.width}px` }}
                    key={`${item.type}${i}`}
                    label={item.labelName}
                    colon={item.colon}>
                    {item.param
                      ? getFieldDecorator(item.param.name, {
                          rules: [
                            {
                              type: item.param.type,
                              required: item.requiredRule
                                ? this.state.visible[item.requiredRule.name] ===
                                  item.requiredRule.value
                                : item.required,
                              message: "请输入内容",
                            },
                            {
                              type: item.param.type,
                              validator: item.validator
                                ? (rule, value, callback) => {
                                    this.rulesMap[item.validator.vtype](
                                      rule,
                                      value,
                                      callback,
                                      item.validator,
                                    );
                                  }
                                : null,
                            },
                          ],
                          valuePropName: itemvaluePropName,
                          initialValue: item.defaultValue,
                          getValueFromEvent: item.getValueFromEvent,
                        })(
                          item.type ? (
                            this.formMap[item.type](item)
                          ) : (
                            <Plugin
                              key={item.param.name}
                              values={item.defaultValue}
                              paramName={item.param.name}
                              getFieldDecorator={getFieldDecorator}
                              disabled={this.computedDisabled(item)}
                            />
                          ),
                        )
                      : this.formMap[item.type](item)}
                    {item.radio && (
                      <Radio
                        className={item.radio.radioGroup}
                        onClick={(e) => this.radioHandler(e, i, item.radio.radioGroup)}
                        checked={item.radio.checked}
                      />
                    )}
                    {item.button && (
                      <Button
                        type={item.button.style}
                        className="form-list-btn"
                        loading={this.state[`${item.param.name}_loading`] || !1}
                        onClick={(e) => item.button.handler(e, item.inputObj, this)}>
                        {item.button.name}
                      </Button>
                    )}
                    {Plugin && Plugin.rightbar}
                  </FormItem>
                )}

                {/* 表单后的说明文字 */}
                {item.info && (
                  <FormItem
                    label={" "}
                    className={`${layout === "inline" ? "sc-form-list" : "sc-row"} ${
                      item.info && "newlineInfo"
                    }`}
                    colon={false}>
                    <div dangerouslySetInnerHTML={{ __html: item.info }}></div>
                  </FormItem>
                )}
              </div>
            )
          );
        })}
      </Form>
    );
  }

  componentWillUnMount = () => {
    if (this.lazyLoad) {
      clearTimeout(this.lazyLoad);
    }
  };

  setBirthdayMonth() {
    // 设置生日月份变量
    this.birthdayMonth = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    const birthdayBaseDate = [];
    const opts = this.birthdayMonth.map((item) => {
      return {
        value: `${item}`,
        label: item < 10 ? `0${item}` : `${item}`,
        isLeaf: false,
      };
    });
    for (let i = 1; i <= 26; i++) {
      birthdayBaseDate.push({
        label: i < 10 ? `0${i}` : `${i}`,
        value: `${i}`,
        isLeaf: true,
      });
    }
    this.setState({
      birthdayOptions: opts,
      birthdayBaseDate,
    });
  }

  setBirthdayDate(maxDate) {
    // 设置生日日期变量
    console.log("maxDate", maxDate);
    const opts = [];
    for (let i = 27; i <= maxDate; i++) {
      opts.push({
        label: `${i}`,
        value: `${i}`,
        isLeaf: true,
      });
    }
    return this.state.birthdayBaseDate.concat(opts);
    // this.setState({
    // birthdayOptions:this.state.birthdayBaseDate.concat(options)
    // })
  }

  componentWillMount() {
    this.setBirthdayMonth();
  }

  componentDidMount() {
    // const store = this.context.store;
    // store.subscribe(() => {//为了解决closeModals的时候会清空查旬表单
    //     store.getState().modalInfo.key && (store.getState().modalInfo.visible === !1 )\
    // && this.handleReset();
    // });
    const { formConfig } = this.props;
    if (formConfig.initSearch) {
      this.handleSubmit();
    }
    if (this.props.formConfig.formTarget === "grid") {
      if (this.props.formConfig.autoLoadGrid) {
        this.props.form.validateFields((err) => {
          if (!err) {
            this.lazyLoad = setTimeout(() => {
              this.fetchGrid(this.props.formConfig.defaultParams, this.props.formConfig.tableKey);
            }, 500);
          }
        });
      }
    }
    for (const cit of this.props.formConfig.childItems) {
      if (cit.param) {
        this.state.visible[cit.param.name] = cit.defaultValue;
        this.state.disabled[cit.param.name] = cit.defaultValue;
        this.setState({
          visible: this.state.visible,
          disabled: this.state.disabled,
          fetching: false,
        });
      }
    }
    if (typeof this.props.getInstance === "function") {
      this.props.getInstance(this);
    }
  }
}

const WrapFormCore = Form.create()(FormCore);

export default injectIntl(WrapFormCore);

FormCore.propTypes = {
  formConfig: PropTypes.object.isRequired,
  fetchApi: PropTypes.func.isRequired,
  getInstance: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/AntD/components/display/form/formCore.js